import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
export function AtomError(msg, code) {
  this.errMsg = msg;
  this.errCode = code;
}

AtomError.prototype.toString = function () {
  return this.errMsg + (this.errCode ? "(".concat(this.errCode, ")") : '');
};